var $0eaea02111df1682$exports = {};
// --------------------------------------------------------
// Header visuals effect
let $0eaea02111df1682$var$visual = document.getElementById("visual");
let $0eaea02111df1682$var$visual2 = document.getElementById("visual2");
let $0eaea02111df1682$var$offset = 0;
let $0eaea02111df1682$var$dir = 1;
// setInterval(() => {
//     let max = visual.clientWidth - window.innerWidth;
//     updateVisuals([visual, visual2]);
//     offset += dir * 1.5;
//     if(offset >= max) {
//         dir = -1;
//         offset = max;
//     } else if(offset <= 0) {
//         dir = 1;
//         offset = 0;
//     }
// }, 10);
document.addEventListener("mousemove", (event)=>{
    $0eaea02111df1682$var$offset = event.clientX * 0.05;
    $0eaea02111df1682$var$updateVisuals([
        $0eaea02111df1682$var$visual,
        $0eaea02111df1682$var$visual2
    ]);
});
function $0eaea02111df1682$var$updateVisuals(visuals) {
    for (const element of visuals)// visual.style.transform = `translateX(-${window.scrollY}px)`;
    element.style.transform = `translateX(-${$0eaea02111df1682$var$offset}px)`;
} // --------------------------------------------------------


//# sourceMappingURL=portfolio.ddbbb9b2.js.map
